<template>
	<div :class="['action-group-item', { 'action-group-item--danger': danger }]">
		<button @click="actionGoTo" class="action-group-item__button">
			<span>{{ title }}</span>
		</button>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
	name: 'action-group-item',
	props: {
		title: {
			type: String,
			default: null
		},
		danger: {
			type: Boolean,
			default: false
		}
	},
	methods: {
		actionGoTo() {
			this.$parent.$emit('close')
			this.$emit('click')
		}
	}
}
</script>

<style scoped>
a > span,
button > span {
	transform: translate(0, 0);
	transition: all 300ms;
	display: inline-block;
}
a:hover > span,
button:hover > span {
	transform: translate(5px, 0);
	text-shadow: #333 0 0 1px, #333 0 0 1px;
}
.action-group-item {
	padding: 0 20px;
	position: relative;
}
.action-group-item::after {
	content: ' ';
	display: block;
	height: 100%;
	width: 5px;
	background-color: var(--main-color);
	position: absolute;
	top: 0;
	right: 0;
	opacity: 0;
	transition: opacity 0.3s;
}
.action-group-item.action-group-item--active::after {
	opacity: 1;
}
.action-group-item__button {
	border: 0;
	border-bottom: 1px solid #f0f0f0;
	background: transparent;
	color: #333;
	font-size: 12px;
	box-sizing: border-box;
	cursor: pointer;
	text-decoration: none;
	outline: none;
	position: relative;
	transition: color 0.3s;
	width: 100%;
	display: flex;
	justify-content: flex-start;
	padding: 10px;
}
.action-group-item__button > span {
	padding: 7px 0;
	display: block;
	white-space: nowrap;
}
.action-group-item.action-group-item--active .action-group-item__button {
	font-weight: 700;
}
.action-group-item:last-child .action-group-item__button {
	border-bottom: 1px solid transparent;
}
.action-group-item--danger {
	background-color: #FFEBEE;
}
.action-group-item--danger .action-group-item__button {
	color: #F44336;
}
.action-group-item--danger .action-group-item__button:hover > span {
	text-shadow: #F44336 0 0 1px, #F44336 0 0 1px;
}
</style>



// WEBPACK FOOTER //
// src/modules/ui/ActionGroupItemButton.vue